import { Directive, ElementRef, OnInit, HostListener, Input } from '@angular/core';

import { LoginService } from '../../core/service/login.service';

@Directive({
    selector: '[appHideIfUnauthorized]'
})
export class HideIfUnauthorizedDirective /*implements OnInit*/ {

    @Input('appHideIfUnauthorized') permission: string;

    constructor(
        private element: ElementRef,
        private login: LoginService) {
        // this.element.nativeElement.style.fontSize = "x-large";   
    }

    ngOnInit() {
        if (!this.login.hasPermission(this.permission)) {
            this.element.nativeElement.style.display = 'none';
        }
    }

}
